module.exports = __webpack_public_path__ + "img/ads2.0f282b9d.webp";